export default __webpack_public_path__ + "static/media/empty-filter.85ac2c9f.png";